import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { BACKEND_PIVOT } from 'core/constants/endpoints'
import store from 'utils/store/withMiddleware'
import { toString } from 'utils/pivot/product'

function parseCarrierId(carrierId) {
  return carrierId == 3 ? 'CLIC' : 'NRIC'
}

function getPlans(state) {
  const plans = state.recommended.concat(state.plansToShow)

  return plans.map(planId => {
    const plan = state.plans[planId]

    if (plan) {
      const policyPeriodAccessKey = plan.durations[state.period]
        ? plan.durations[state.period]
        : plan.durations[Object.keys(plan.durations).slice(-1)[0]]
      const policy = policyPeriodAccessKey['1'] || policyPeriodAccessKey['2']
      return {
        carrierId: parseCarrierId(plan.carrierId),
        carrierName: state.carriers[plan.carrierId].name,
        deductible: plan.coreBenefits.deductible,
        drugDeductible: `${plan.coreBenefits.deductible} Ded then ${plan.coreBenefits.officeVisitCopay}`,
        oop: plan.coreBenefits.outOfPocketMax,
        planName: plan.planName,
        planType: toString(plan.productId),
        premiumPrepaid: policy.prepaid ? +policy.prepaid.premium : undefined,
        premiumMonthly: +policy.monthly.premium,
        planId: plan.legacyId,
        block: state.recommended.includes(plan.planId) ? 'recommend' : 'main'
      }
    }
  })
}

export default function recommendTrackingEvents(storeRef = store) {
  const state = storeRef.getState()
  if (state.recEngine) {
    const hcStorage = state.hcStorage
    const plansHolder = getPlans(state)
    const dataPayload = {
      searchMetaData: {
        order:
          state.recEngine.order_by === 'plan_id' ? 'default' : state.recEngine.order_by,
        placement: hcStorage.placement,
        zipCode: hcStorage.location.zip_code,
        houseHoldSize: hcStorage.household.size,
        eventId: state.recEngine.event_id || '',
        sessionId: hcStorage.healthcareSession,
        channel: hcStorage.channel.channelName.toLowerCase(),
        url: window.location.href,
        experiment_id: state.recEngine.experiment_id
      },
      results: plansHolder
    }

    fetchJSONHandleError({
      url: `${BACKEND_PIVOT}/v2/recommendTracking`,
      data: dataPayload
    })
  }

  return storeRef
}
